// Tracking IDs for Google Analytics 4 and Meta (Facebook) Pixel.
//
// PASTE YOUR IDs HERE - leave a value blank ("") to disable that vendor.
//
// Google Analytics 4 measurement ID looks like: "G-XXXXXXXXXX"
//   Find it in Admin → Data Streams → Web → Measurement ID.
//
// Meta Pixel ID looks like a 15–16 digit number, e.g. "123456789012345"
//   Find it in Meta Events Manager → Data sources → your pixel.
//
// Google Ads conversion (optional) lets us also send signup/enquiry
// conversions to Google Ads. Format: "AW-XXXXXXXXX" and the label is the
// part after the slash in the conversion snippet ("AW-XXXXX/abcDEFghi").
//
// All tracking is GATED on cookie consent ("eal-advertising-consent-v1" key in
// localStorage). Nothing fires until the user accepts.

export const TRACKING = {
  ga4Id: "",
  metaPixelId: "",
  googleAdsId: "AW-18393669488",
  googleAdsSignupLabel: "kJndCI_I6-IcEPC-5MJE",
  googleAdsEnquiryLabel: "",
} as const;
